(function() {
    'use strict';

    angular.module('format')
        .controller('FormatGroupCreateController', FormatGroupCreateController);

    FormatGroupCreateController.$inject = ['$state', 'notificationSrvc', 'formatGroupDataSrvc', 'formatGroupMessagesConst', 'errorNotificationSrvc'];

    function FormatGroupCreateController($state, notificationSrvc, formatGroupDataSrvc, formatGroupMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            name_de: [],
            name_en: [],
            name_cpde: [],
            name_cpen: [],
            nonFieldErrors: []
        };
        self.groupData = {
            nam_pl: null,
            name_de: null,
            name_en: null,
            name_cpde: null,
            name_cpen: null
        };

        self.groups = [];

        self.createGroup = createGroup;
        self.cleanErrors = cleanErrors;

        function createGroup() {
            formatGroupDataSrvc.create(
                self.groupData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", formatGroupMessagesConst.add);
                    $state.go('layout.formatGroup.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
